export const ERROR_SERVER = 'ERROR_SERVER';
export const SET_EMPLOYEE = 'SET_EMPLOYEE';
export const SET_EXIT_EMPLOYEE = 'SET_EXIT_EMPLOYEE';
export const SET_ACCESS_VISIT = 'SET_ACCESS_VISIT';
export const SET_EXIT_VISIT = 'SET_EXIT_VISIT';
export const SET_TYPE = 'SET_TYPE';
export const GET_ACCESS_CONTRACTORS = 'GET_ACCESS_CONTRACTORS';
export const CLEAN = 'CLEAN';
export const SET_STEP = 'SET_STEP';
export const SET_EXIT = 'SET_EXIT';
export const SET_ACCESS_WITH = 'SET_ACCESS_WITH';
export const CANT_ACCESS_EMPLOYEE = 'CANT_ACCESS_EMPLOYEE';
export const CONFIRM_ACCESS = 'CONFIRM_ACCESS';
export const CONFIRM_EXIT = 'CONFIRM_EXIT';
export const ERROR_ACCESS = 'ERROR_ACCESS';
export const CONFIRMING_MOVEMENT = 'CONFIRMING_MOVEMENT';
export const SET_VISIT = 'SET_VISIT';